import { Injectable, signal } from '@angular/core';

/**
 * Open/close state for the full-screen home-hub overlay. The trigger lives in
 * the sidebar header (the "Create" product button) while the overlay itself is
 * rendered at app-root level, so the state is shared through this service.
 */
@Injectable({ providedIn: 'root' })
export class HomeHubOverlayService {
  private readonly _isOpen = signal(false);
  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }
}
